var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.$t('researches')}},[_c('BaseButton',{class:[
      'OrderQuizButton btn-link btn-simple btn-github',
      { Disabled: _vm._.isEmpty(_vm.order.afterSaleQuizId) },
    ],attrs:{"size":"sm","icon":""},on:{"click":_vm.openQuiz}},[_c('i',{staticClass:"fas fa-question"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }